module.exports = __webpack_public_path__ + "static/media/checkmark-limeGreen.2a1673a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/checkmark-limeGreen.svg
// module id = 1613
// module chunks = 0